import { ICreateDeviceContext } from './createDeviceContext';
import { IDeviceBankSettingForCreate } from 'types';

export enum CreateDeviceActionTypes {
	CHANGE_HARDWARE_ID = 'CHANGE_HARDWARE_ID',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_BANK_SETTINGS = 'SET_BANK_SETTINGS',
	ADD_BANK_SETTINGS_BLOCK = 'ADD_BANK_SETTINGS_BLOCK',
	SET_FETCHED_RESTAURANT_BANK_SETTINGS = 'SET_FETCHED_RESTAURANT_BANK_SETTINGS',
	SET_TLS_CERTIFICATE_LEVEL = 'SET_TLS_CERTIFICATE_LEVEL',
	CHANGE_TLS_CERTIFICATE_NAME = 'CHANGE_TLS_CERTIFICATE_NAME',
	SET_TLS_CERTIFICATE_FILE = 'SET_TLS_CERTIFICATE_FILE',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeHardwareId {
	type: CreateDeviceActionTypes.CHANGE_HARDWARE_ID;
	payload: {
		hardwareId: ICreateDeviceContext['hardwareId'];
	};
}

interface ISetFetchedCustomers {
	type: CreateDeviceActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: ICreateDeviceContext['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: CreateDeviceActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: ICreateDeviceContext['IDSelectedCustomer'];
	};
}

interface ISetFetchedRestaurants {
	type: CreateDeviceActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: ICreateDeviceContext['fetchedRestaurants'];
	};
}

interface ISetIDRestaurant {
	type: CreateDeviceActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: ICreateDeviceContext['IDSelectedRestaurant'];
	};
}

interface ISetBankSettings {
	type: CreateDeviceActionTypes.SET_BANK_SETTINGS;
	payload: {
		bankSettings: ICreateDeviceContext['bankSettings'];
	};
}

interface IAddBankSettingsBlock {
	type: CreateDeviceActionTypes.ADD_BANK_SETTINGS_BLOCK;
	payload: {
		bankSettings: IDeviceBankSettingForCreate;
	};
}

interface ISetFetchedRestaurantBankSettings {
	type: CreateDeviceActionTypes.SET_FETCHED_RESTAURANT_BANK_SETTINGS;
	payload: {
		fetchedRestaurantBankSettings: ICreateDeviceContext['fetchedRestaurantBankSettings'];
	};
}

interface ISetTlsCertificateLevel {
	type: CreateDeviceActionTypes.SET_TLS_CERTIFICATE_LEVEL;
	payload: {
		tlsCertificateLevel: ICreateDeviceContext['tlsCertificateLevel'];
		tlsCertificateName: ICreateDeviceContext['tlsCertificateName'];
		tlsCertificateFileId: ICreateDeviceContext['tlsCertificateFileId'];
		tlsCertificateFileHash: ICreateDeviceContext['tlsCertificateFileHash'];
	};
}

interface IChangeTlsCertificateName {
	type: CreateDeviceActionTypes.CHANGE_TLS_CERTIFICATE_NAME;
	payload: {
		tlsCertificateName: ICreateDeviceContext['tlsCertificateName'];
	};
}

interface ISetTlsCertificateFile {
	type: CreateDeviceActionTypes.SET_TLS_CERTIFICATE_FILE;
	payload: {
		tlsCertificateFileId: ICreateDeviceContext['tlsCertificateFileId'];
		tlsCertificateFileHash: ICreateDeviceContext['tlsCertificateFileHash'];
	};
}

interface ISetDataForSubmit {
	type: CreateDeviceActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateDeviceContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateDeviceActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ICreateDeviceContext['typeOfModalWindow'];
	};
}

interface IShowErrorModalWithInfo {
	type: CreateDeviceActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: ICreateDeviceContext['errorResponseData'];
	};
}

interface IResetSelectedControls {
	type: CreateDeviceActionTypes.RESET_FIELDS;
}

export type TCreateDeviceAction =
	| IChangeHardwareId
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetFetchedRestaurants
	| ISetIDRestaurant
	| ISetBankSettings
	| IAddBankSettingsBlock
	| ISetFetchedRestaurantBankSettings
	| ISetTlsCertificateLevel
	| IChangeTlsCertificateName
	| ISetTlsCertificateFile
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo
	| IResetSelectedControls;
